module.exports = __webpack_public_path__ + "img/Candreva.a2c2445a.png";